import React from 'react'

const StaffMember = ({ staffMember }) => {
  const { id, fullName} =  staffMember.attributes

  return (
    <div className="list-group-item">
      <div>
        <a href={`/admin/users/${id}`} className="fw-medium">{ fullName }</a>
      </div>
    </div>
  )
}

export default StaffMember
